module.exports = __webpack_public_path__ + "static/img/kefu2 (1).8a89258b.png";